import Ticket from ".";

export const ticketRoutes = (data) => [
  {
    path: "/:lang/admin/tickets",
    title: "Page",
    layout: "admin",
    routeType: "admin",
    component: Ticket,
  },
];
